// Imports
import { Base, DataTypes, SubmitTypes, ErrorTypes } from '@mixins/forms'
import Cookies from 'js-cookie'
// Parts
const { ObjectDataType: dataType } = DataTypes
const { AjaxSubmit: submitType } = SubmitTypes
const { FanRegisterError: errorHandling } = ErrorTypes

// Options
const options = {
  name: 'fomo:join',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: true,
    validation: true,
    submit: { events: {} },
    error: true
  }
}

// Component
export default {
  name: 'fan-registration-form',
  mixins: [
    Base(options),
  ],
  props: {
    source: {
      type: String,
      default: 'global'
    },
    isOneTimeCode: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    parsedFormSourceParam: new URL(window.location.href).searchParams.get('source')
  }),
  methods: {
    extendSubmitTracking(data) {
      return {
        events: {
          newsletterSignup: data?.profile?.newsletter ?? false,
          onetimecoderegistration: this.isOneTimeCode ? true : false,
          ipadregistration: this.isOneTimeCode ? false : true,
        },
        user: {
          accountNumber: data?.profile?.fanId?.toLowerCase(),
          accountType: data?.profile?.loyalLevel,
          loginState: 'logged in',
          ireckonuID: data?.profile?.personId?.toString() || null
        },
        registration: {
          source: this.source ? this.source : this.parsedFormSourceParam !== null ? this.parsedFormSourceParam : ''
        }
      }
    },
    transformRedirectUrl(url, data) {
      let redirectUrlQueryString =  new URLSearchParams(window.location.search)
      redirectUrlQueryString = redirectUrlQueryString.get('returnUrl') || false
      if (redirectUrlQueryString && !(this.redirectUrl.endsWith(redirectUrlQueryString))) {
        return redirectUrlQueryString
      } else {
        setTimeout(() => {
          window.location.href = url;
        }, 500);
      }
    },
    async transformResponse() {
      this.form.trigger('reset')
    },
  }
}
